import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  menuBarOffset: theme.mixins.toolbar,
  installmentsSpacing: {
    padding: '9px'
  },
  scrollTopButton: {
    position: 'fixed',
    bottom: theme.spacing(10),
    right: theme.spacing(2),
    zIndex: 5000
  },
  bottomToolbar: {
    top: 'auto',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center'
  },
  largeContainer: {
    minWidth: '200px',
    minHeight: '600px',
    overflow: 'scroll',
    overflowX: 'auto',
    overflowY: 'auto',
    display: 'flex'
  },
  paperContainer: {
    paddingBottom: theme.spacing(5)
  },
  statusStyle: {
    fontStyle: 'italic'
  },
  attachmentTooltip: {
    backgroundColor: '#F7B500',
    borderRadius: 10
  },
  attachmentTooltipArrow: {
    fontSize: 16,
    color: '#F7B500'
  },
  bottomButtons: {
    fontSize: 12,
    color: '#005f9e',
    marginTop: 20
  },
  bottomButtonsDivider: {
    backgroundColor: '#FFF',
    marginTop: theme.spacing(1.8),
    marginBottom: theme.spacing(1.8),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  }
}));

export default useStyles;
